{
  "email": "邮箱",
  "emailAddress": "邮箱地址",
  "emailAddressPlaceholder": "请输入您的邮箱地址",
  "continue": "继续",
  "send": "发送",
  "resend": "重新发送",
  "sendCodeErrorTip": "发送验证码失败：{error}",
  "sendEmailTips": "我们已向您的邮箱发送验证码",
  "verificationCode": "验证码",
  "codePlaceholder": "请输入验证码",
  "wallet": "钱包",
  "otherLoginMethods": "其他登录方式",
  "login": "登录",
  "user": "用户",
  "loginTitle": "登录 / 注册",
  "loginTips": "您可以使用以下方式登录",
  "passwordMinError": "密码必须至少包含 {length} 个字符",
  "passwordMatchError": "两次输入的密码不一致",
  "passwordTitle": "设置密码",
  "passwordTips": "请设置用于恢复钱包的钱包密码",
  "password": "密码",
  "passwordPlaceholder": "请输入您的密码",
  "rePassword": "确认密码",
  "rePasswordPlaceholder": "请再次输入密码",
  "recoverTitle": "恢复钱包",
  "recoverTips": "请输入您的密码以恢复钱包",
  "bindWith": "绑定 {name} 钱包",
  "loginWith": "使用 {name} 钱包登录",
  "editUsernameTitle": "修改用户名",
  "setUsernameTitle": "设置用户名",
  "username": "用户名",
  "usernamePlaceholder": "请输入您的用户名",
  "usernameValidError": "用户名可以由数字、字母和字符组成",
  "usernameLengthError": "用户名不得少于 2 个字符",
  "confirm": "确认",
  "nextTime": "下次再说",
  "setUsername": "设置用户名",
  "disconnect": "断开连接",
  "CEXBindTitle": "绑定 {type} API",
  "CEXBindAttention": "注意：",
  "CEXBindTips1": "1. 请绑定具有只读权限的 API。",
  "CEXBindTips2": "2. 您的 API 可能已过期，建议使用长期有效的 API。",
  "CEXBindTips3": "3. 同一时间只能绑定一个 API 到相同的交易所。",
  "CEXBindApiKey": "API 密钥",
  "CEXBindApiSecretKey": "API 秘钥",
  "CEXBindApiPassphrase": "API 密码短语",
  "cancel": "取消",
  "walletLoading": "钱包服务正在加载",
  "tokenDetails": "代币详情",
  "tokenAmountMin": "金额必须大于 0。",
  "tokenAmountMax": "余额不足。",
  "tokenAddressError": "无效的地址。",
  "amount": "金额",
  "amountPlaceholder": "请输入金额。",
  "balance": "余额",
  "receiveTitle": "接收钱包地址",
  "receivePlaceholder": "请输入接收钱包地址。",
  "next": "下一步",
  "copied": "已复制",
  "receiveQrcode": "扫描 QR 码接收",
  "copyAddress": "复制地址",
  "tokenSmartContract": "代币智能合约",
  "tokenSmartContractPlaceholder": "请输入代币智能合约。",
  "tokenSymbol": "代币符号",
  "tokenSymbolPlaceholder": "请输入代币符号。",
  "tokenDecimals": "小数位数",
  "tokenDecimalsPlaceholder": "请输入小数位数。",
  "import": "导入",
  "receive": "接收",
  "customizedToken": "自定义代币",
  "noMoreRecords": "没有更多交易记录了！",
  "noRecords": "暂无交易记录！",
  "close": "关闭",
  "back": "返回",
  "importSuccess": "成功导入代币",
  "importFail": "导入代币失败",
  "changeNetwork": "切换网络",
  "approveSuccess": "授权成功",
  "Approve": "授权",
  "noFriends": "暂无好友",
  "noRequests": "暂无请求",
  "noMore": "没有更多",
  "Remove": "移除",
  "removeSuccess": "移除成功"
}